import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScreenService {
  getPPI(): number {
    const div = document.createElement('div');
    div.style.width = '1in';
    div.style.visibility = 'hidden';
    document.body.appendChild(div);

    const ppi = div.offsetWidth;
    document.body.removeChild(div);

    return ppi;
  }

  getCmPerPixel(): number {
    const ppi = this.getPPI();
    return 1 / (ppi / 2.54);
  }
}
